import {
  AUTHENTICATION_URL,
  BASE_URL,
  PROJECT_STATUSES,
  PROJECT_TAGS,
} from "../src/constants/constants";
import { getProjectStatus, getFilters } from "../src/utils";

const PROJECT_END_POINT = `${BASE_URL}/api/projects`

export const getProjectDetailService = (id) => {
  return fetch(`${PROJECT_END_POINT}/${id}?populate=%2A`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
  })
    .then((response) => {
      return response;
    })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAllProject = () => {
  return fetch(`${PROJECT_END_POINT}/?populate=%2A`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
  })
    .then((response) => {
      return response;
    })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

const requestOptions = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    Authorization: AUTHENTICATION_URL,
  },
  redirect: "follow",
};

export const getProjectListingService = async (
  address,
  pageNumber = 1,
  pageSize = 10
) => {
  let endpointURL = `${PROJECT_END_POINT}?filters[deployer][$eq]=${address}&sort[0]=createdAt%3Adesc&publicationState=preview&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&populate=*`;
  const result = await fetch(endpointURL, requestOptions);
  const response = await result.json();
  response.data.forEach((project) => {
    if (!project.attributes.publishedAt) {
      project.attributes.project_status = PROJECT_STATUSES.DRAFT;
    } else {
      let { project_start_time, project_end_time } = project.attributes;
      project.attributes.project_status = getProjectStatus(
        project_start_time,
        project_end_time
      );
    }
  });
  let pagination = response.meta.pagination;
  return { projects: response.data, pagination };
};

const getEndpoints = (chainId) => {
  
  let {
    upcomingFilters,
    completedFilters,
    liveFilters,
    featuredFilters,
    flaggedFilters,
  } = getFilters();

  const endpoints = chainId
    ? {
        upcomingEndpointURL: `${PROJECT_END_POINT}?${
          upcomingFilters + `&filters[$and][2][chain][chain_id]=${chainId}`
        }&[sort]=project_start_time:asc`,
        completedEndpointURL: `${PROJECT_END_POINT}?${
          completedFilters + `&filters[$and][2][chain][chain_id]=${chainId}`
        }&[sort]=project_end_time:desc`,
        liveEndpointURL: `${PROJECT_END_POINT}?${
          liveFilters + `&filters[$and][3][chain][chain_id]=${chainId}`
        }&[sort]=project_end_time:asc`,
        featuredProjects: `${PROJECT_END_POINT}?${
          featuredFilters + `&filters[$and][2][chain][chain_id]=${chainId}`
        }&[sort]=project_start_time:desc`,
        flaggedEndPoint: `${PROJECT_END_POINT}?${
          flaggedFilters + `&filters[$and][1][chain][chain_id]=${chainId}`
        }&[sort]=project_start_time:desc`,
        allProjectsEndpoint: `${PROJECT_END_POINT}?&filters[$and][1][chain][chain_id]=${chainId}&sort[0]=createdAt%3Adesc`,
      }
    : {
        upcomingEndpointURL: `${PROJECT_END_POINT}?${upcomingFilters}&[sort]=project_start_time:asc`,
        completedEndpointURL: `${PROJECT_END_POINT}?${completedFilters}&[sort]=project_end_time:desc`,
        liveEndpointURL: `${PROJECT_END_POINT}?${liveFilters}&[sort]=project_end_time:asc`,
        featuredProjects: `${PROJECT_END_POINT}?${featuredFilters}&[sort]=project_start_time:desc`,
        flaggedEndPoint: `${PROJECT_END_POINT}?${flaggedFilters}&[sort]=project_start_time:desc`,
        allProjectsEndpoint: `${PROJECT_END_POINT}?&sort[0]=createdAt%3Adesc`,
      };
  return endpoints;
};

export const fetchProjects = async (
  status,
  chainId,
  pageNumber = 1,
  pageSize = 12
) => {
  let {
    upcomingEndpointURL,
    completedEndpointURL,
    liveEndpointURL,
    featuredProjects,
    flaggedEndPoint,
    allProjectsEndpoint
  } = getEndpoints(chainId);

  let endpointURL;

  switch (status) {
    case PROJECT_STATUSES.UPCOMING:
      endpointURL = upcomingEndpointURL;
      break;
    case PROJECT_STATUSES.LIVE:
      endpointURL = liveEndpointURL;
      break;
    case PROJECT_STATUSES.COMPLETED:
      endpointURL = completedEndpointURL;
      break;
    case PROJECT_TAGS.FEATURED:
      endpointURL = featuredProjects;
      break;
    case PROJECT_TAGS.FLAGGED:
      endpointURL = flaggedEndPoint;
      break;
    case PROJECT_STATUSES.ALL:
      endpointURL = allProjectsEndpoint;
      break;
  }

  endpointURL += `&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&populate=*`;

  const result = await fetch(endpointURL, requestOptions);
  const response = await result.json();

  let dataMakingArray = response.data.map((project) => {
    let projects = {
      id: project.id,
      ...project.attributes,
      project_status: status,
    };

    switch(status){
      case PROJECT_STATUSES.UPCOMING:
        projects.project_status = PROJECT_STATUSES.UPCOMING;
        break;
      case PROJECT_STATUSES.LIVE:
        projects.project_status = PROJECT_STATUSES.LIVE;
        break;
      case PROJECT_STATUSES.COMPLETED:
        projects.project_status = PROJECT_STATUSES.COMPLETED;
        break;
      default:
        let {project_start_time, project_end_time} = projects;
        projects.project_status = getProjectStatus(
            project_start_time,
            project_end_time
        );
        break;
    }
    return projects;
  });
  return { data: dataMakingArray, meta: response.meta };
};

export const getBlockchains = async () => {
  const endpoint = `${BASE_URL}/api/blockchains`;
  const fetchCall = await fetch(endpoint, requestOptions);
  const response = await fetchCall.json();
  let blockchains = {};
  response.data.forEach(
    (chain) => (blockchains[chain.attributes.chain_id] = chain.id)
  );
  return blockchains;
};

export const getProjectVersions = async () => {
  const endpoint = `${BASE_URL}/api/project-versions?filters[version][$eq]=v-1`;
  const fetchCall = await fetch(endpoint, requestOptions);
  const response = await fetchCall.json();

  if(!response.data) return;
  if(response.data.length == 0) return;

  let latestVersion = response.data[0].id;

  return latestVersion;
};


export const getPublicTiers = async () => {
  const endpoint = `${BASE_URL}/api/wallet-tiers?filters[tier_label][$eq]=Public`;
  const fetchCall = await fetch(endpoint, requestOptions);
  const response = await fetchCall.json();
  if(!response.data) return;
  if(response.data.length == 0) return;
  return response.data[0].id;
}
